export const GET_ASSESSMENT_LIST = "GET_ASSESSMENT_LIST"
export const GET_ASSESSMENT_LIST_SUCCESS = "GET_ASSESSMENT_LIST_SUCCESS"
export const GET_ASSESSMENT_LIST_FAILED = "GET_ASSESSMENT_LIST_FAILED"

//view question list
export const GET_VIEW_ASSESSMENT_LIST = "GET_VIEW_ASSESSMENT_LIST"
export const GET_VIEW_ASSESSMENT_LIST_SUCCESS = "GET_VIEW_ASSESSMENT_LIST_SUCCESS"
export const GET_VIEW_ASSESSMENT_LIST_FAIL = "GET_VIEW_ASSESSMENT_LIST_FAIL"

//changeStatus 
export const UPDATE_ACTIVITY_STATUS = "UPDATE_ACTIVITY_STATUS"
export const UPDATE_ACTIVITY_STATUS_SUCCESS = "UPDATE_ACTIVITY_STATUS_SUCCESS"
export const UPDATE_ACTIVITY_STATUS_FAIL = "UPDATE_ACTIVITY_STATUS_FAIL"


//submit selected question
export const POST_SELECTED_QUESTION = "POST_SELECTED_QUESTION"
export const UPDATE_SELECTED_QUESTION = "UPDATE_SELECTED_QUESTION"
export const POST_SELECTED_QUESTION_SUCCESS = "POST_SELECTED_QUESTION_SUCCESS"
export const POST_SELECTED_QUESTION_FAIL = "POST_SELECTED_QUESTION_FAIL"

//  add assessment question
export const SEARCH_QUESTION_FROM_QUESTION_BANK = "SEARCH_QUESTION_FROM_QUESTION_BANK"
export const SEARCH_QUESTION_FROM_QUESTION_BANK_SUCCESS = "SEARCH_QUESTION_FROM_QUESTION_BANK_SUCCESS"
export const SEARCH_QUESTION_FROM_QUESTION_BANK_FAIL = "SEARCH_QUESTION_FROM_QUESTION_BANK_FAIL"

